import * as React from 'react';

import { useIsMobileDevice } from '../../../../hooks';

import {
  TCommercialOwnershipVerificationFormViewState,
  ECommercialOwnershipVerificationFormViewFields,
} from '../CommercialOwnershipVerificationForm';
import {
  fieldsByType,
  LABELS_BY_FIELD_NAME,
  identificationPersonTypeSelectOptions,
} from '../CommercialOwnershipVerificationForm/internal/maps';

import { FormPreview as Component, IFormPreview } from './FormPreview';

interface IFormPreviewContainer extends Omit<IFormPreview, 'fields' | 'isMobile'> {
  formState: Partial<TCommercialOwnershipVerificationFormViewState> | undefined;
}

export const FormPreview: React.FC<IFormPreviewContainer> = props => {
  const { formState, ...otherProps } = props;

  const fields = React.useMemo(() => {
    if (!formState) {
      return [];
    }

    /* istanbul ignore next */
    const identificationPersonType = formState?.identificationPersonType?.value || 'none';
    const visibleFields = fieldsByType[identificationPersonType].visible;

    return visibleFields
      .map(el => {
        if (el === ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType) {
          /* istanbul ignore next */
          const elementValue = formState[el]?.value;
          const mapValue = identificationPersonTypeSelectOptions.find(item => item.value === elementValue);

          /* istanbul ignore next */
          return {
            label: LABELS_BY_FIELD_NAME[el],
            value: mapValue?.label || '—',
          };
        }

        /* istanbul ignore next */
        if (el === ECommercialOwnershipVerificationFormViewFields.CompanyName && !formState[el]?.value) {
          return null;
        }

        return { label: LABELS_BY_FIELD_NAME[el], value: formState[el]?.value || '—' };
      })
      .filter(Boolean) as IFormPreview['fields'];
  }, []);

  const isMobile = useIsMobileDevice();

  return <Component {...otherProps} fields={fields} isMobile={isMobile} />;
};

FormPreview.displayName = 'FormPreviewContainer';
